import agent from "src/api/agent";

export const getCouponCodes = () => agent.requests.get(`/Web/getcouponcodes`);

export const getBranches = () => agent.requests.get(`/Web/Branch`);

export const getGroupCodes = () => agent.requests.get(`/Web/getgroupcodes`);

export const getCouponCodeDetails = (id) => agent.requests.post(`/Web/getcouponcodedetails`, id);

export const createCouponCode = (data) => agent.requests.post(`/Web/createcouponcode`, data);

export const updateCouponCode = (data) => agent.requests.post(`/Web/updatecouponcode`, data);

export const uploadCouponCodes = (file) => agent.requests.postMulti(`/Web/uploadcouponsfromexcel`, file);